module.exports = __webpack_public_path__ + "img/MC.05c17018.svg";